import type { Scenario } from '../types/content'

export const scenarios: Scenario[] = [
  {
    situation: 'A swimmer struggles with freestyle breathing?',
    answer: 'You have a lesson progression.',
  },
  { situation: 'Need another exercise?', answer: 'You have 150 drills.' },
  {
    situation: 'The technique still looks wrong?',
    answer: 'You have 100 mistakes and corrections.',
  },
  { situation: 'The group is losing focus?', answer: 'You have 50 skill-based games.' },
  {
    situation: 'Not sure whether the swimmer is ready to progress?',
    answer: 'Open the assessment system.',
  },
  {
    situation: 'The pool is crowded and your original lesson no longer works?',
    answer: 'You have 40 backup lessons.',
  },
]

export const questionsAnswered: string[] = [
  'What should I teach?',
  'How should I teach it?',
  'What drill should I use?',
  'What should I say?',
  'What do I do if the swimmer struggles?',
  'How can I make it easier?',
  'How can I make it harder?',
  'How do I know when they are ready to progress?',
]
